import React, { useEffect, useState } from "react";
import { Flex, Dropdown, Input } from "@fluentui/react-northstar";
import findIndex from "lodash/findIndex";
import { useDashboardMonth } from "../../queries";
import { monthNames, getStartOfMonth } from "../../common/dateOperations";
import { numberToString } from "../../common/numberOperations";
import styles from "./yearMonthPicker.module.scss";

const YearMonthPicker: React.FunctionComponent = () => {
    const [startOfMonth, setStartOfMonth] = useState(getStartOfMonth(new Date().getFullYear(), new Date().getMonth()));
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState<string>(monthNames[new Date().getMonth()]);

    const { data: dashboardMonth } = useDashboardMonth(startOfMonth);
    const monthData = dashboardMonth ?? 0;

    useEffect(() => {
        if (selectedYear < 2000 || isNaN(selectedYear)) {
            return;
        }

        const monthIndex = findIndex(monthNames, (x: string) => x === selectedMonth);
        setStartOfMonth(getStartOfMonth(selectedYear, monthIndex));
    }, [selectedMonth, selectedYear]);

    const monthChanged = (_: any, data: any) => {
        setSelectedMonth(data.value);
    };

    const yearChanged = (_: any, data: any) => {
        setSelectedYear(data.value);
    };

    return (
        <Flex column gap="gap.small">
            <Flex gap="gap.small">
                <Input value={selectedYear} onChange={yearChanged} className={styles.yearInput} />
                <Dropdown items={monthNames} value={selectedMonth} onChange={monthChanged} className={styles.monthInput} />
            </Flex>
            <div>
                <strong>{numberToString(monthData)}</strong> <span>hodin za měsíc</span>
            </div>
        </Flex>
    );
};

export default YearMonthPicker;
